module.exports = __webpack_public_path__ + "static/logo-hubble-og-95353f299797fbe22aa28f8a82185c13.png";